const Data = {
    headding: "Give with confidence to NPOs with our Trust & Transparency Seals",
    MapItems: [
        {
            seal: "PLATINUM",
            seal1: ["PLATINUM"],
            image: '/Images/Seal design_page-0001.jpg',
            discription: 'Based on GuideStar India’s seven pillar assessment rubric covering Situation Analysis, Theory of Change, Programme Intervention & Resilience, Infrastructure, Finance & Compliance, Governance & Accountability, Evidence of Impact, Learning & Reflection'
        },
        {
            seal: "GOLD",
            seal1: ["GOLD"],
            image: '/Images/Seal design_page-0002.jpg',
            discription: 'Based on GuideStar India’s seven pillar assessment rubric covering Situation Analysis, Theory of Change, Programme Intervention & Resilience, Infrastructure, Finance & Compliance, Governance & Accountability, Evidence of Impact, Learning & Reflection'
        },
        {
            seal: "SILVER",
            seal1: ["SILVER"],
            image: '/Images/Seal design_page-0003.jpg',
            discription: 'Based on GuideStar India’s seven pillar assessment rubric covering Situation Analysis, Theory of Change, Programme Intervention & Resilience, Infrastructure, Finance & Compliance, Governance & Accountability, Evidence of Impact, Learning & Reflection'
        },
        {
            seal: "BRONZE +",
            seal1: ["BRONZE +"],
            image: '/Images/Seal design_page-0005.jpg',
            discription: 'Based on GuideStar India’s seven pillar assessment rubric covering Situation Analysis, Theory of Change, Programme Intervention & Resilience, Infrastructure, Finance & Compliance, Governance & Accountability, Evidence of Impact, Learning & Reflection'
        },
        {
            seal: "BRONZE",
            seal1: ["BRONZE"],
            image: '/Images/Seal design_page-0004.jpg',
            discription: 'Based on GuideStar India’s seven pillar assessment rubric covering Situation Analysis, Theory of Change, Programme Intervention & Resilience, Infrastructure, Finance & Compliance, Governance & Accountability, Evidence of Impact, Learning & Reflection'
        },
    ]
}
export { Data } 